module.exports = __webpack_public_path__ + "img/socialmedia.793439a4.svg";